import { configureStore } from '@reduxjs/toolkit';

import cruiseListApp from '../reducers/cruiseList';
import cruiseListQueryMiddleware from '../middleware/cruiseListQuery';

// **`common` is the host-page state object, seeded through `preloadedState`** — not a reducer. The
// slice it lands in declares no reducers, so nothing but this seeding ever writes to it.
//
// **Both of RTK's dev checks are on**, and leaving them on is what made Bug 175869 unavoidable
// rather than invisible.
//
// **`prepend`, not `concat`.** The listener middleware is added ahead of the default set, which is
// what RTK prescribes, so the listener sees each action before anything else in the chain can
// alter it. The effects still run after the reducer either way, because the listener passes the
// action on before matching.
//
// `devTools` is dev-only deliberately; see the other factories.
export const createCruiseListStore = (common) =>
  configureStore({
    reducer: cruiseListApp,
    preloadedState: { common },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(cruiseListQueryMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
